export const SALE_STATUS_NAME_MAP = {
  enable: "Ativa",
  disable: "Inativa",
  paid: "Aprovada",
  completed: "Completa",
  pending: "Aguardando pagamento",
  past_due: "Atrasada",
  created: "Iniciada",
  failed: "Falha na transação",
  smart: "Aprovada",
  chargeback: "Chargeback",
  reversal_manual: "Estorno manual",
  reversal: "Estorno automático",
  reversal_manual_admin: "Estorno manual",
  webhook_reversal: "Estorno manual"
};

export const SALE_STATUS_BACKGROUND_COLOR_MAP = {
  paid: "#C2E0B97A",
  enable: "#C2E0B97A",
  chargeback: "#FFCBCB7A",
  completed: "#C2E0B97A",
  smart: "#C2E0B97A",
  reversal_manual: "#FFCBCB7A",
  reversal_manual_admin: "#FFCBCB7A",
  reversal: "#FFCBCB7A",
  disable: "#FFCBCB7A",
  pending: "#FFD43A7A",
  past_due: "#FFD43A7A",
  created: "#D7D7D77A",
  failed: "#FFCBCB7A"
};

export const SALE_STATUS_COLOR_MAP = {
  paid: "#228F01",
  enable: "#228F01",
  completed: "#228F01",
  smart: "#228F01",
  reversal_manual: "#BF2E30",
  reversal_manual_admin: "#BF2E30",
  reversal: "#BF2E30",
  disable: "#BF2E30",
  pending: "#AB6F0C",
  past_due: "#AB6F0C",
  created: "#666666",
  failed: "#BF2E30"
};

export const SALE_STATUS_BADGE_MAP = {
  paid: "active-badge",
  enable: "active-badge",
  smart: "active-badge",
  completed: "active-badge",
  pending: "draft-badge",
  past_due: "draft-badge",
  created: "draft-badge",
  chargeback: "incomplete-badge",
  failed: "inactive-badge",
  reversal: "inactive-badge",
  reversal_manual: "inactive-badge",
  disable: "inactive-badge",
  webhook_reversal: "inactive-badge",
  reversal_manual_admin: "inactive-badge"
};

export const SALE_PAY_METHOD_NAME_MAP = {
  card: "Cartão de crédito",
  credit_card: "Cartão de crédito",
  smart_card: "Parcelamento inteligente",
  billet: "Boleto",
  boleto: "Boleto",
  two_card: "Dois cartões",
  pix: "Pix",
  google_pay: "Google Pay",
  paypal: "Paypal",
  null: "N/A"
};

export const SALE_PAY_METHOD_COLOR_MAP = {
  card: "#04c56b",
  credit_card: "#04c56b",
  smart_card: "#04c56b",
  two_card: "#74Affc",
  billet: "#feca57",
  boleto: "#feca57",
  pix: "#ee6469",
  google_pay: "#ff9233",
  paypal: "#5576ec",
  null: "#000"
};

export const ABREVIATION_TO_SYMBOL_MAP = {
  ARS: "$",
  BOB: "Bs.F.",
  BRL: "R$",
  CLP: "$",
  COP: "$",
  EUR: "€",
  MXN: "Mex$",
  PYG: "₲",
  USD: "$",
  UYU: "$U"
};

export const PERIODICITY_NAME_MAP = {
  monthly: "Mensal",
  bimonthly: "Bimestral",
  quarterly: "Trimestral",
  half: "Semestral",
  yearly: "Anual"
};

export const PERIODICITY_NUMBER_MAP = {
  weekly: 52,
  monthly: 12,
  bimonthly: 6,
  quarterly: 4,
  half: 2,
  yearly: 1
};

export const SUBSCRIPTION_STATUS_NAME_MAP = {
  enable: "Ativa",
  pending: "Cobrança Futura",
  started: "Iniciada",
  paused: "Pausada",
  completed: "Finalizada",
  disable: "Inativa",
  disable_by_admin: "Cancelada pelo Administrador",
  disable_by_producer: "Cancelada pelo Produtor",
  disable_by_client: "Cancelada pelo Cliente",
  past_due: "Atrasada",
  expired: "Finalizada",
  fail: "Assinatura com Falha",
  exception: "Em Análise"
};

export const SUBSCRIPTION_STATUS_BADGE_MAP = {
  enable: "active-badge",
  started: "active-badge",
  completed: "active-badge",
  paused: "draft-badge",
  pending: "draft-badge",
  exception: "draft-badge",
  disable: "inactive-badge",
  past_due: "inactive-badge",
  expired: "inactive-badge",
  fail: "inactive-badge",
  disable_by_admin: "inactive-badge",
  disable_by_producer: "inactive-badge",
  disable_by_client: "inactive-badge"
};
